import { Component, OnInit, ViewChildren, QueryList, ElementRef, Input } from '@angular/core';
import { TreeNode, MessageService } from 'primeng/api';
import { HttpClient } from '@angular/common/http';
import { UploadNewDocComponent } from '../upload-new-doc/upload-new-doc.component';
import { EditDocumentComponent } from '../edit-doc/edit-doc.component';
import { DocumentManagementService } from 'src/framework/services/manage-doc.service';
import { LabelcardMgmtService } from 'src/framework/services/labelcard-mgmt.service';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { FolderManagementService } from 'src/framework/services/folder-mgmt.service';
import { DocverHistoryService } from 'src/framework/services/docver-history.service';
import { UserService } from 'src/framework/services/userservice';
import { ModalContentComponent } from 'src/app/shared/modal-component/modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'
import * as _ from 'lodash';
import { CategoryConstant } from 'src/app/shared/app-constants/category-constants';
import { LanguageService } from 'src/framework/services/language.service';
import { AppConfigService } from 'src/framework/services/app-config.service';


@Component({
  selector: 'app-manage-doc',
  templateUrl: './manage-doc.component.html',
  styleUrls: ['./manage-doc.component.css'],
  providers: [MessageService]
})

export class ManageDocComponent implements OnInit {
  @Input() approvalVersionId = 0;
  @ViewChildren('uploadNewDocComponent') uploadNewDoc: QueryList<UploadNewDocComponent>;
  @ViewChildren('editDocComponent') editDoc: QueryList<EditDocumentComponent>;
  @ViewChildren('ctrlAddTab') ctrlAddTab: QueryList<ElementRef>;
  @ViewChildren('ctrlEditTab') ctrlEditTab: QueryList<ElementRef>;

  selectedNode: TreeNode;
  targetTreeData: any[];
  showSideBar = false;
  showFileVersionGrid = false;
  docVersionList: any[] = [];
  gridVersionList: any[] = [];
  engagementDocList: any[] = [];
  processedDocIdList: any[] = [];
  cols: any[];
  colmns: any[];
  editDocVersionList: any[] = [];
  addTabIndex = 0;
  editTabIndex = 0;
  appLangList: any[] = [];
  docStatusList: any[] = [];
  docTypeList: any[] = [];
  maxSeed: number = 0;
  documentVersionHistoryModel: any[]
  showHistory = false;
  isApproveDisabled = false;
  public columnOptions: any[];
  exportColumns: any[];
  bsModalRef: BsModalRef;
  fileName = "";

  engagementDetail = {
    appLanguage: 1,
    engagementId: 1,
    engagementName: '',
    engStatusId: 1,
    engStatusName: '',
    engInitialDate: null,
    engLanguage: [{
      "languageId": 1,
      "languageName": "English",
      "languageFlagPath": "../../assets/flags/English.png"
    }],
    engLanguageFrench: [{
      "languageId": 1,
      "languageName": "Anglaise",
      "languageFlagPath": "../../assets/flags/English.png"
    }]
  }
  showDocVersionTypeId: number;
  isUnapproved: boolean = true;
  showEditSideBar: boolean;
  documentss = [];
  languageList:any;
  saveMsg: string;
  userDetail: any = {};
  isAllNonApproved: boolean = false;
  canApproveOtherLang: boolean = false;
  selectedFilePath: string;
  userList: any[] = [];
  uploadFileKey: any = null;
  versionGridColList: any[];
  selectedAppLanguage: any;
  selectedAppLanguageJson: any;
  defaultEnglishJson: any;
  selectedLangDocTypeJson: any;
  defaultEngDocTypeJson: any;
  selectedLangStatusJson: any;
  defaultEngStatusJson: any;
  selectedLangLabelJson: any;
  defaultEngLangLabelJson: any;
  selectedLangDateJson: any;
  defaultEngDateJson: any;
  islabelLoaded: boolean = false;
  languageLists=[];
  selectedGlobalLanguageJson: any;
  defaultGlobalEnglishJson: any
  isValid: boolean = false;
  inValidFieldCounter: number = 0;
  compactHistoryList: any[];
  showCompactLog: boolean = false;
  viewLogList: any[];


  constructor(private http: HttpClient, private manageDocService: DocumentManagementService,
    private labelCardService: LabelcardMgmtService, private spinner: NgxSpinnerService,
    private datePipe: DatePipe, private folderService: FolderManagementService,
    private messageService: MessageService, private DocService: DocverHistoryService,
    private modalService: BsModalService, private userService: UserService,
    private appConfigService: AppConfigService,
    private languageService: LanguageService
  ) {


  }

  ngOnInit(): void {
    this.fileName = "documentVersionHistoryLogs_export_" + new Date().getTime();
    if (sessionStorage.getItem('userDetail')) {
      this.userDetail = JSON.parse(sessionStorage.getItem('userDetail'));
    }
    
    this.initializeEngagementData()
      .then(res => {
        this.loadLanguageLabel()
          .then(res => {
            this.loadMasterData()
              .then(res =>
                this.getEngagementDoc()
                  .then(res => {
                    //this.initializeGridColumns()
                    this.getFolderStructure();
                    this.getLanguages()
                    // .then(res => this.pTree.filterGlobal('', 'contains'))
                    // .catch(err => {
                    //   console.log(err);
                    // })
                  })
                  .catch(err => {
                    console.log(err);
                  })
              )
              .catch(err => {
                console.log(err);
              });
          })
          .catch(err => {
            console.log(err);
          });
      })
      .catch(err => {
        console.log(err);
      });
  }


  initializeEngagementData() {
    return new Promise((resolve, reject) => {
      if (sessionStorage.getItem('appLanguageList')) {
        this.appLangList = JSON.parse(sessionStorage.getItem('appLanguageList'));
      }
      else {
        this.getLanguageList();
      }
      if (sessionStorage.getItem('engagementDetail')) {
        this.engagementDetail = JSON.parse(sessionStorage.getItem('engagementDetail'));

      }
      resolve(1);
    });
  }

  initializeGridColumns() {
    return new Promise((resolve, reject) => {
      this.cols = [
        { field: 'statusName', header: this.labelReplacer('colStatus') },
        { field: 'languageName', header: this.labelReplacer('colLanguage') },
        { field: 'documentLink', header: this.labelReplacer('colDocument') },
        { field: 'documentTitle', header: this.labelReplacer('colTitle') },
        { field: 'documentDescription', header: this.labelReplacer('colDescription') },
        { field: 'documentType', header: this.labelReplacer('colType') },
        { field: 'documentDateStr', header: this.labelReplacer('colDate') },
        { field: 'authorizedByEmail', header: this.labelReplacer('colApprover') }
      ];
      this.colmns = [
        { field: 'docId', header: this.labelReplacer('colLogDocumentID') },
        { field: 'docVersionId', header: this.labelReplacer('colLogDocumentVersionID') },
        { field: 'languageName', header: this.labelReplacer('colLogLanguage') },
        { field: 'statusName', header: this.labelReplacer('colLogStatus') },
        { field: 'currentAuthorized', header: this.labelReplacer('colLogCurrentApproved') },
        { field: 'currentDraft', header: this.labelReplacer('colLogCurrentDraft') },
        { field: 'documentTitle', header: this.labelReplacer('colLogDocTitle') },
        { field: 'documentDescription', header: this.labelReplacer('colLogDocumentDesc') },
        { field: 'documentDate', header: this.labelReplacer('colLogDocDate') },
        { field: 'documentLink', header: this.labelReplacer('colLogDocLink') },
        { field: 'documentHash', header: this.labelReplacer('colLogDocHash') },
        { field: 'createdBy', header: this.labelReplacer('colLogDocCreatedBy') },
        { field: 'createdDate', header: this.labelReplacer('colLogCreatedDate') },
        { field: 'approvalRequestedByGpn', header: this.labelReplacer('colLogApprovalReqBy') },
        { field: 'approvalRequestedFromGpn', header: this.labelReplacer('colLogApprovalReqFrom') },
        { field: 'approvalRequestedStringFormat', header: this.labelReplacer('colLogApprovalReqDttm') },
        { field: 'authorizedByGpn', header: this.labelReplacer('colLogApprovedBy') },
        { field: 'authorizedStringFormat', header: this.labelReplacer('colLogApprovedDttm') },
        { field: 'postedDateStringFormat', header: this.labelReplacer('colLogPostedDt') },
        { field: 'authorizationEndedByGpn', header: this.labelReplacer('colLogApprovalEndedBy') },
        { field: 'authorizationEndStringFormat', header: this.labelReplacer('colLogApprovalEndDttm') },
        { field: 'externalViews', header: this.labelReplacer('colLogExtViews') },
        { field: 'logCreatedDate', header: this.labelReplacer('colLogCreatedDttm') },
        { field: 'logCreatedBy', header: this.labelReplacer('colLogCreatedBy') }
      ];

      this.exportColumns = this.colmns.map(col => ({ title: col.header, dataKey: col.field }));

      //initialize colums
      this.versionGridColList = [];
      this.versionGridColList = this.cols.map(x => ({
        label: x?.header,
        value: x
      }));

      this.columnOptions = [];
      this.columnOptions = this.colmns.map(x => ({
        label: x?.header,
        value: x
      }));

      resolve(1);
    });
  }

  loadLanguageLabel() {
    let englishLanguageMappings, selectedLanguageMappings: any;
    let englishDocTypeMappings, selectedLangDocTypeMappings: any;
    let englishStatusMappings, selectedLangStatusMappings: any;
    let englishLangLabelMappings, selectedLangLabelMappings: any;
    let englishDateMappings, selectedLangDateMappings: any;
    let englishglobalLanguageMappings, selectedglobalLanguageMappings: any;

    return new Promise((resolve, reject) => {
      if (sessionStorage.getItem('selectedLanguageId')) {
        this.selectedAppLanguage = 1;//JSON.parse(sessionStorage.getItem('selectedLanguageId'));
      }

      this.languageService.currentData.subscribe(data => {
        this.spinner.show();
        this.selectedAppLanguage = data.Id
        this.engagementDetail.appLanguage = this.selectedAppLanguage;
      });


      this.languageService.mySubject.subscribe((data) => {
        var languageMappings = data;
        if (languageMappings?.length > 0) {

          englishLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.ManageDocument.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishDocTypeMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.DocumentTypes.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishStatusMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishLangLabelMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishDateMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          englishglobalLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.Global.toLowerCase()
            && Number(item?.languageId) === 1)[0];

          if (englishLanguageMappings?.isGlobal) {
            selectedLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.ManageDocument.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

            selectedLangDocTypeMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.DocumentTypes.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

            selectedLangStatusMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

            selectedLangLabelMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

            selectedLangDateMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

            selectedglobalLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.Global.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];
          }
          else {
            if (Number(this.selectedAppLanguage) === 2) {
              selectedLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.ManageDocument.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

              selectedLangDocTypeMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.DocumentTypes.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

              selectedLangStatusMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Status.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

              selectedLangLabelMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Language.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];

              selectedLangDateMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Calendar.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];


              selectedglobalLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.Global.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedAppLanguage))[0];
            }
            else {
              selectedLanguageMappings = englishLanguageMappings;
              selectedLangDocTypeMappings = englishDocTypeMappings;
              selectedLangStatusMappings = englishStatusMappings;
              selectedLangLabelMappings = englishLangLabelMappings;
              selectedLangDateMappings = englishDateMappings;
              selectedglobalLanguageMappings = englishglobalLanguageMappings;
            }
          }

          this.selectedAppLanguageJson = JSON.parse(selectedLanguageMappings?.languageMappingJSON ?? englishLanguageMappings.languageMappingJSON);
          this.defaultEnglishJson = JSON.parse(englishLanguageMappings.languageMappingJSON);

          this.selectedLangDocTypeJson = JSON.parse(selectedLangDocTypeMappings?.languageMappingJSON ?? englishDocTypeMappings.languageMappingJSON);
          this.defaultEngDocTypeJson = JSON.parse(englishDocTypeMappings.languageMappingJSON);

          this.selectedLangStatusJson = JSON.parse(selectedLangStatusMappings?.languageMappingJSON ?? englishStatusMappings.languageMappingJSON);
          this.defaultEngStatusJson = JSON.parse(englishStatusMappings.languageMappingJSON);

          this.selectedLangLabelJson = JSON.parse(selectedLangLabelMappings?.languageMappingJSON ?? englishLangLabelMappings.languageMappingJSON);
          this.defaultEngLangLabelJson = JSON.parse(englishLangLabelMappings.languageMappingJSON);

          this.selectedLangDateJson = JSON.parse(selectedLangDateMappings?.languageMappingJSON ?? englishDateMappings.languageMappingJSON);
          this.defaultEngDateJson = JSON.parse(englishDateMappings.languageMappingJSON);

          this.selectedGlobalLanguageJson = JSON.parse(selectedglobalLanguageMappings.languageMappingJSON);
          this.defaultGlobalEnglishJson = JSON.parse(englishglobalLanguageMappings.languageMappingJSON);

          this.reloadDocumentData()
            .then(res => {
              this.islabelLoaded = true;
              this.spinner.hide();
            })
          resolve(1);
        }
        else {
          this.spinner.hide();
        }
      });
    })
      .catch(err => {
        this.spinner.hide();

        console.log(err);
      });
  }



  getLanguages() {
    this.appConfigService.getLanguageList().subscribe((response: any) => {
      if (response) {
        this.languageLists = response;
      }
    });
  }




  preLoadData() {

    return new Promise((resolve, reject) => {
      this.labelCardService.getLanguageList().subscribe(res => {
        if (res) {
          //success
          res.forEach(element => {
            if (element.isAppLanguage) {
              this.languageList.push({
                languageId: element.languageId,
                languageName: element.name,
                languageFlagPath: element.languagePath
              });
            }
          });

        } else {
          //display error
          //reject();
        }
        resolve(1);

      });
    })
      .catch(err => {
        console.log(err);
      });

  }

  reloadDocumentData() {
    return new Promise((resolve, reject) => {
      this.spinner.show();
      this.initializeGridColumns();
      this.showFileVersionGrid = false;
      this.showHistory = false;
      if (this.islabelLoaded) {
        this.getFolderStructure();
        this.spinner.hide();
      }
      this.spinner.hide();
      resolve(1);
    });

  }

  labelReplacer(labelKey): string {
    return this.selectedAppLanguageJson[labelKey]?.trim() ? this.selectedAppLanguageJson[labelKey] ?? 'text not found' : this.defaultEnglishJson[labelKey] ?? 'text not found';
  }

  docTypeReplacer(labelKey): string {
    return this.selectedLangDocTypeJson[labelKey]?.trim() ? this.selectedLangDocTypeJson[labelKey] ?? 'text not found' : this.defaultEngDocTypeJson[labelKey] ?? 'text not found';
  }


  activeReplacer(labelKey): string {
    return this.selectedGlobalLanguageJson[labelKey]?.trim() ? this.selectedGlobalLanguageJson[labelKey] ?? 'text not found' : this.defaultGlobalEnglishJson[labelKey] ?? 'text not found';
  }

  statusReplacer(labelKey): string {
    return this.selectedLangStatusJson[labelKey]?.trim() ? this.selectedLangStatusJson[labelKey] ?? 'text not found' : this.defaultEngStatusJson[labelKey] ?? 'text not found';
  }

  languageReplacer(labelKey): string {
    return this.selectedLangLabelJson[labelKey]?.trim() ? this.selectedLangLabelJson[labelKey] ?? 'text not found' : this.defaultEngLangLabelJson[labelKey] ?? 'text not found';
  }

  monthReplacer(labelKey): string {
    let localeDt;
    if (labelKey) {
      let arr = labelKey.split(' ');
      if (arr?.length == 3)
        localeDt = arr[0] + ' ' + this.calendarReplacer(arr[1]?.toUpperCase()) + ' ' + arr[2];
      else if (arr?.length == 4)
        localeDt = arr[0] + ' ' + this.calendarReplacer(arr[1]?.toUpperCase()) + ' ' + arr[2] + ' ' + arr[3];
      else
        localeDt = labelKey;
    }
    return localeDt;
  }

  calendarReplacer(labelKey): string {
    return this.selectedLangDateJson[labelKey]?.trim() ? this.selectedLangDateJson[labelKey] ?? 'text not found' : this.defaultEngDateJson[labelKey] ?? 'text not found';
  }

  dayOrMonthNameShort(name, length): string {
    let shortName = '';
    if (name?.trim()?.length == 0)
      shortName = 'Text not found';
    else if (name?.trim()?.length > 0 && name?.trim()?.length < length)
      shortName = name;
    else
      shortName = name.substr(0, length);
    return shortName;
  }

  getFolderStructure() {
    return new Promise((resolve, reject) => {
      this.spinner.show();
      this.folderService.getFolderTemplate(this.engagementDetail.engagementId).then(files => {
        var count: Array<number>=[];
        if (files.length > 0 && files[0].children) {
          let i =0;
          files[0].children.forEach(childNode => {
          if(childNode ==null || childNode.label==undefined)
          {
            count.push(i);
          }
          i = i+1;
        });
        }
        
        count.forEach( val =>{
          files[0].children.splice(val,1);
        });
       
        this.targetTreeData = files.length > 0 ? files : [];
        this.preProcessTree();
        this.collapseAll();
        this.checkForApprovalScreenRedirect();
        this.spinner.hide();
      });
      resolve(1);
    })
      .catch(err => {
        this.spinner.hide();
        console.log(err);
      });

  }

  checkForApprovalScreenRedirect() {
    if (this.approvalVersionId != 0 && this.approvalVersionId != undefined && this.approvalVersionId !== null) {
      let searchDoc = this.findDocument(this.approvalVersionId)

      if (searchDoc !== null && searchDoc !== undefined) {
        this.showFileVersionGrid = true;
        this.selectedNode = searchDoc;
        if (this.selectedNode.data != null && this.selectedNode.data != undefined) {
          let parentNode = this.findNode(this.selectedNode.data[0]?.parentId);
          parentNode.expanded = true;
          this.viewFileVersion(searchDoc);
        }
      }
      // if (this.documentss.length > 0) {
      //   this.viewTopicFileVersion(this.documentss[0]);
      // }
    }
  }

  preProcessTree() {
    this.processedDocIdList = [];

    return new Promise((resolve, reject) => {
      this.targetTreeData.forEach(x => {
        this.preProcessTreeRecursive(x)
      });
      resolve(1);
    });

  }

  preProcessTreeRecursive(node: TreeNode) {
    if (node != null && node != undefined) {
      if (node.type.toLowerCase() === 'file') {
        node.draggable = true;
        node.droppable = false;
        this.toggleFileDisplay(node as TreeNode);
      }
      else if (node.type.toLowerCase() === 'folder' || node.type.toLowerCase() === 'structure') {
        node.draggable = false;
        node.droppable = true;
        this.sortNode(node);
      }
      if (node.children) {
        node.children.forEach(childNode => {
          this.preProcessTreeRecursive(childNode);
        });
      }
    }

  }

  displayFolderLabel(node: TreeNode): string {

    let primaryLangId, otherPrimaryLangId = 0;
    let nodeLangList: any[] = [];
    let langIndex = -1;
    let folderLabel = '';

    if (node != null && node != undefined) {
      if (this.engagementDetail.appLanguage == 2) {
        primaryLangId = 2;
        otherPrimaryLangId = 1;
      }
      else //default is english
      {
        primaryLangId = 1;
        otherPrimaryLangId = 2;
      }

      folderLabel = node?.label;
      nodeLangList = node?.data[0]?.language;

      if (nodeLangList?.length > 0) {
        if ((langIndex = nodeLangList.findIndex(x => Number(x.languageId) === Number(primaryLangId))) > -1) {
          if (nodeLangList[langIndex]?.folderName?.trim() !== ''
            && nodeLangList[langIndex]?.folderName !== null
            && nodeLangList[langIndex]?.folderName !== undefined) {
            folderLabel = nodeLangList[langIndex]?.folderName;
          }
          else {
            if ((langIndex = nodeLangList.findIndex(x => Number(x.languageId) === Number(otherPrimaryLangId))) > -1) {
              if (nodeLangList[langIndex]?.folderName?.trim() !== ''
                && nodeLangList[langIndex]?.folderName !== null
                && nodeLangList[langIndex]?.folderName !== undefined) {
                folderLabel = nodeLangList[langIndex]?.folderName;
              }
            }
          }
        }
      }
    }

    return folderLabel;

  }

  // Start function
  findNode(nodeKey): TreeNode {

    var found = false;
    let foundNode: TreeNode = {};

    function recurseFindParent(searchTree) {

      for (var i = 0; i < searchTree.length; i++) {

        // Found the category!
        if (Number(searchTree[i].key) === Number(nodeKey)) {
          foundNode = searchTree[i];
          found = true;
          break;

          // Did not match...
        } else {
          // Are there children / sub-categories? YES
          if (searchTree[i].children.length > 0) {
            recurseFindParent(searchTree[i].children);
            if (found) {
              break;
            }
          }
        }
      }
    }

    recurseFindParent(this.targetTreeData);

    return foundNode;
  }


  toggleFileDisplay(node: TreeNode) {
    let primaryLangId, otherPrimaryLangId = 0;
    let currentDocId = 0;
    let treeVersionList: any[] = [];
    let detailVersionList: any[] = [];
    let matchFound = false;

    if (this.engagementDetail.appLanguage == 2) {
      primaryLangId = 2;
      otherPrimaryLangId = 1;
    }
    else //default is english
    {
      primaryLangId = 1;
      otherPrimaryLangId = 2;
    }

    if (!this.processedDocIdList?.includes(node?.data[0]?.docId)) {
      currentDocId = node?.data[0]?.docId;
      this.processedDocIdList.push(currentDocId);

      let parentNode = this.findNode(node.data[0]?.parentId);
      //fetch all versions for current docid from tree
      treeVersionList = parentNode?.children?.filter(x => Number(x.data[0]?.docId) === Number(currentDocId));
      detailVersionList = this.engagementDocList?.filter(x => Number(x.docId) === Number(currentDocId))[0]?.documentVersionList;

      if (treeVersionList && detailVersionList) {

        if (treeVersionList?.length === detailVersionList?.length) {

          matchFound = this.isDisplayVersionInSelectedLang(treeVersionList, detailVersionList, primaryLangId);

          if (!matchFound) {
            this.isDisplayVersionInSelectedLang(treeVersionList, detailVersionList, otherPrimaryLangId);
          }
        }
      }
    }

  }

  isDisplayVersionInSelectedLang(treeVersionList: any[], detailVersionList: any[], primaryLangId): boolean {
    let unAuthList: any[] = [];
    let authIndex, draftIndex, unAuthIndex = -1;
    let fileStyle = [];
    const isAnyAuthorized = (x) => (x.currentAuthorized && !x.currentDraft);
    const isAnyDraft = (x) => (!x.currentAuthorized && x.currentDraft
      && x.approvalRequestedByGpn === null && x.approvalRequestedFromGpn === null);
    const isAnyAuthPending = (x) => (!x.currentAuthorized && x.currentDraft
      && x.approvalRequestedByGpn != null && x.approvalRequestedFromGpn != null
      && x.authorizedByGpn === null && x.authorizedDateTime === null);

    if (!detailVersionList.some(isAnyAuthorized)) {
      fileStyle.push('G');
      if (detailVersionList.some(isAnyAuthPending)) {
        fileStyle.push('A');
      }
    }
    else if (detailVersionList.some(isAnyAuthPending)) {
      fileStyle.push('A');
    }
    else if (detailVersionList.some(isAnyDraft)) {
      fileStyle.push('D');
    }


    //check for current authorized version in selected language
    authIndex = detailVersionList?.findIndex(x => x.currentAuthorized
      && !x.currentDraft && Number(x.languageId) === Number(primaryLangId));
    //check for current draft version in selected language
    draftIndex = detailVersionList?.findIndex(x => !x.currentAuthorized
      && x.currentDraft && Number(x.languageId) === Number(primaryLangId));
    //check for unauthorized versions in selected language
    unAuthList = detailVersionList?.filter(x => !x.currentAuthorized
      && !x.currentDraft && Number(x.languageId) === Number(primaryLangId))?.sort(this.date_sort_desc);
    if (authIndex > -1) {
      this.setFileToggleClass(treeVersionList, detailVersionList, authIndex, fileStyle);
    }
    else if (draftIndex > -1) {
      this.setFileToggleClass(treeVersionList, detailVersionList, draftIndex, fileStyle);
    }
    else {
      if (unAuthList.length > 0) {
        unAuthIndex = detailVersionList.indexOf(unAuthList[0]);
        this.setFileToggleClass(treeVersionList, detailVersionList, unAuthIndex, fileStyle);

      }
    }

    if (authIndex === -1 && draftIndex === -1 && unAuthIndex === -1) {
      return false;
    }
    return true;

  }

  setFileToggleClass(treeVersionList, detailVersionList, versionIndex, fileStyle) {
    treeVersionList.forEach(x => {
      if (Number(x?.data[0]?.docVersionId) === Number(detailVersionList[versionIndex]?.docVersionId)) {
        x['styleClass'] = 'fileClass';
        x['docId'] = detailVersionList[versionIndex]?.docId;
        x.data[0].showDraftMark = false;
        x.data[0].showRedMark = false;

        //Add additonal styles to visible file
        if (fileStyle.length > 0) {
          fileStyle.forEach(style => {
            if (style === 'G') {
              x['styleClass'] = 'fileClass grayFileClass';
            }
            if (style === 'D') {
              x.data[0].showDraftMark = true;
            }
            if (style === 'A') {
              x.data[0].showRedMark = true;
            }
          });
        }

      }
      else {
        x['styleClass'] = 'fileClass hideFileClass';
        x['docId'] = detailVersionList[versionIndex]?.docId;
      }
    });
  }

  get globalIdentitySeed() {

    if (this.targetTreeData.length > 0) {

      this.targetTreeData.forEach(node => {
        this.getMaxSeedValue(node);
      });
    }

    return this.maxSeed;
  }

  set globalIdentitySeed(value) {
    this.maxSeed = value;
  }

  getMaxSeedValue(node: TreeNode) {

    if (this.maxSeed < Number(node.key)) {
      this.maxSeed = Number(node.key);
    }
    if (node.children) {
      node.children.forEach(childNode => {
        this.getMaxSeedValue(childNode);
      });
    }

  }

  getStatusPillClass(statusId: Number) {

    let pillClass = '';
    if (statusId) {
      if (statusId === 2 || statusId === 4 || statusId === 7)
        pillClass = 'pill pill--approved m-0';
      else if (statusId === 1)
        pillClass = 'pill pill--closed m-0';
      else if (statusId === 3 || statusId === 6)
        pillClass = 'pill pill--failed m-0';
      // else if (statusId === 'authorized')
      //   pillClass = 'pill pill--hold m-0';
    }

    return pillClass;
  }

  loadMasterData() {
    return new Promise((resolve, reject) => {
      this.getDocType()
        .then(res =>
          this.getDocStatus()
            .then(res =>
              this.getUserList()
                .then(res =>
                  resolve(1))
            ))
        .catch(error => console.log(error));
    });


  }

  getUserList() {
    return new Promise((resolve, reject) => {
      this.userService.GetUserList().subscribe(res => {
        if (res.status === 0) {
          //success
          this.userList = res.data;
        } else {
          //display error
        }
        resolve(1);
      });
    });
  }
  getDocStatus() {

    return new Promise((resolve, reject) => {
      this.manageDocService.getDocStatus().subscribe(res => {
        if (res) {
          //success
          this.docStatusList = res.data;
        } else {
          //display error
        }
        resolve(1);
      });
    });
  }

  getDocType() {
    return new Promise((resolve, reject) => {
      this.manageDocService.getDocType().subscribe(res => {
        if (res) {
          //success
          this.docTypeList = res.data;
        } else {
          //display error
        }
        resolve(1);
      });
    });

  }

  getEngagementDoc() {
    return new Promise((resolve, reject) => {
      this.manageDocService.getEngagementDocument(this.engagementDetail).subscribe(res => {
        if (res) {
          //success
          this.engagementDocList = res.data;
        } else {
          //display error
        }
        resolve(1);
      });
    });
  }

  toggleBack() {
    this.showHistory = false;
  }

  getLanguageList() {
    return new Promise((resolve, reject) => {
      this.labelCardService.getLanguageList().subscribe(res => {
        if (res) {
          //success
          // this.appLangList = res;
          res.forEach(element => {
            if (element.isAppLanguage) {
              this.appLangList.push({
                languageId: element.languageId,
                languageName: element.name,
                languageFlagPath: element.languagePath
              });
            }

          });
        } else {
          //display error
        }
        resolve(1);
      });
    });
  }

  sortTree() {
    this.targetTreeData.sort((a, b) => a.label?.localeCompare(b.label));
    this.targetTreeData.forEach(element => {
      element.children?.sort((a, b) => a.label?.localeCompare(b.label));
    });


  }

  getFiles() {
    return this.http.get<any>('../../../../assets/files/treedata.js')
      .toPromise()
      .then(res => <TreeNode[]>res.data);
  }

  nodeSelect(event) {
    let selectedNodeCopy: TreeNode = {};
    this.showHistory = false;

    this.selectedNode = event?.node;

    if (event?.node?.type === 'file') {
      this.showFileVersionGrid = true;
      selectedNodeCopy = _.cloneDeep(this.selectedNode);
      this.setAbsoluteFilePath(selectedNodeCopy, 'edit');
      this.viewFileVersion(event.node);
    }
    else {
      this.showFileVersionGrid = false;
    }
  }

  setAbsoluteFilePath(node: TreeNode, operation: string) {
    let filePath = '';
    this.selectedFilePath = '';
    if (operation == 'edit') {
      node = node.parent;
    }
    while (node?.parent !== undefined && node?.parent !== null) {
      filePath = node.label + '/' + filePath;
      node = node.parent;
    }

    this.selectedFilePath = filePath;
  }

  nodeDrop(event) {
    if(event != null || event != undefined)
    {
     
    let sourceNode: TreeNode = event.dragNode == null || event.dragNode == undefined  ? null : event.dragNode.parent;
    let dragNode: TreeNode = event.dragNode;
    let targetNode: TreeNode = null;
    let versionNodeList: TreeNode[] = [];
    let isReshuffle = false;
    let versionIndex = -1;
     
    

    if ('index' in event) {
      targetNode = event.dropNode;
    }
    else if (event?.hasOwnProperty('dropIndex') && (event.dropNode != null || event.dropNode != undefined)) {
      targetNode = event.dropNode?.parent;
    }

    if(targetNode != null && targetNode != undefined){
      if (sourceNode.key === targetNode.key) {
        isReshuffle = true;
      }
      if (!isReshuffle) {
        dragNode.data[0].parentId = targetNode.key;
        if ('parent' in dragNode) {
           dragNode.parent = targetNode;
        }
        //fetch other versions of the same docid
        if((sourceNode != null && sourceNode != undefined) && (sourceNode.children != null && sourceNode.children != undefined && sourceNode.children.length > 0 ))
        versionNodeList = sourceNode?.children.filter(x => (x != null && x != undefined) && x?.type.toLowerCase() === 'file'
          && (+x?.data[0]?.docId === +dragNode?.data[0]?.docId));
  
        if (versionNodeList != null && versionNodeList != undefined && versionNodeList.length > 0) {
          versionNodeList.forEach(versionNode => {
            if (+versionNode.key !== +dragNode.key) {
              versionIndex = sourceNode?.children.indexOf(versionNode);
              if (versionIndex > -1) {
               
                sourceNode?.children.splice(versionIndex, 1);
                versionNode.data[0].parentId = targetNode.key;
                if (targetNode.children.indexOf(versionNode) === -1) {
                  
                  targetNode.children.push(versionNode);
                  if(sourceNode ==null && versionNode.parent.key != targetNode.key)
                  {
                    sourceNode = versionNode.parent
                  }
                  if(versionNode.parent.key != targetNode.key){
                    versionNode.parent = null;
                  }
                 
                  
                }
              }
            }
          });
  
        }
      }
  
      this.saveTree(false);
      event.dropNode.expanded = true;
    }

    //check for re-position in same folder
    
  }
  }

  saveDragDropChanges(document) {
    this.spinner.show();
    this.manageDocService.moveDocFolder(document).subscribe(res => {
      if (res.status === 0) {
        //success
        this.saveTree(false);
      } else {
        //display error
        this.messageService.add({
          summary: this.labelReplacer('msgTypeErrorDragDrop'),
          detail: res.message,
          sticky: false,
          severity: 'error'
        });
      }
      this.spinner.hide();

    });
  }

  expandAll() {
    this.targetTreeData.forEach(node => {
      this.expandRecursive(node, true);
    });
  }

  collapseAll() {
    this.targetTreeData.forEach(node => {
      this.expandRecursive(node, false);
    });
    if(this.targetTreeData.length>0){
    this.targetTreeData[0].expanded = true;
    }
  }

  expandRecursive(node: TreeNode, isExpand: boolean) {
    node.expanded = isExpand;
    if (node.children) {
      node.children.forEach(childNode => {
        this.expandRecursive(childNode, isExpand);
      });
    }
  }

  getFileIcon(node: TreeNode) {
    let fileType = node.data[0]?.fileType?.toLowerCase();

    //attach file icon based on file type
    if (fileType === '.pdf') {
      node.data[0].fileTypeIcon = 'picture_as_pdf';
      node.data[0].fileIconStyle = '#E0362C';
    }
    else if (fileType === '.doc' || fileType === '.docx' || fileType === '.dot'
      || fileType === '.txt') {
      node.data[0].fileTypeIcon = 'description';
      node.data[0].fileIconStyle = '#1777CF';
    }
    else if (fileType === '.xls' || fileType === '.xlsx' || fileType === '.xlsb'
      || fileType === '.csv') {
      node.data[0].fileTypeIcon = 'insert_chart';
      node.data[0].fileIconStyle = '#189D3E';
    }
    else if (fileType === '.jpg' || fileType === '.jpeg' || fileType === '.png'
      || fileType === '.tif') {
      node.data[0].fileTypeIcon = 'insert_photo';
      node.data[0].fileIconStyle = '#FF6D00';
    }
    else {
      node.data[0].fileTypeIcon = 'help';
    }


  }

  getFileLabel(node: TreeNode) {
    let nodeLabel = '';
    let docDate = '';
    let fileSizeInMb = 0;
    if (node !== null && node != undefined) {
      nodeLabel += node.label + ' - ';
      if (node.data[0]?.documentDate !== null && node.data[0]?.documentDate !== undefined) {
        docDate = new Date(node.data[0]?.documentDate)?.toUTCString();
      }
      else {
        docDate = new Date(node.data[0]?.createdDTTM)?.toUTCString();
      }

      if (docDate !== 'Invalid Date')
        docDate = this.monthReplacer(this.datePipe.transform(docDate, "dd MMM yyyy"));
      nodeLabel += docDate + ' - '

      fileSizeInMb = Math.round((node.data[0]?.fileSize / 1024));

      nodeLabel += fileSizeInMb + ' KB';


      return nodeLabel;
    }
  }

  uploadFile(node) {
    this.uploadFileKey = node?.key ?? null;
    this.setAbsoluteFilePath(node, 'add');
    this.showSideBar = true;
  }

  getSavedDoc(emitSaveVersion) {

    this.spinner.show();
    let emitDocData = emitSaveVersion.versionData;
    this.showSideBar = false;
    if (emitDocData) {

      //add uploaded file to tree json
      this.selectedNode.children.push({
        label: emitDocData.documentTitle,
        key: Date.now().toString(),
        type: "file",
        data: [{
          parentId: this.selectedNode.key,
          docId: emitDocData.docId,
          docVersionId: emitDocData.docVersionId,
          languageId: emitDocData.languageId,
          isFileUploaded: emitDocData.isFileUploaded,
          documentDate: emitDocData.documentDate,
          createdDTTM: new Date(emitDocData.createdDate)?.toUTCString(),
          fileSize: emitDocData.fileLength, //IN MB Math.ceil((emitDocData.fileLength/Math.pow(1024,2)))
          fileType: emitDocData.fileType,
          fileTypeIcon: '',
          fileIconStyle: '#000',
          showRedMark: false,
          showDraftMark: false
        }],
        styleClass: "fileClass",
        children: [],
        draggable: true
      } as TreeNode);

      this.sortNode(this.selectedNode);
      this.selectedNode.expanded = true;

      // //auto save tree with new file added
      // this.saveMsg = this.labelReplacer('msgSuccessAddDoc');
      if (emitSaveVersion?.saveType?.toLowerCase() === 'save') {
        this.saveMsg = this.labelReplacer('msgSuccessAddDoc');
      }
      else if (emitSaveVersion?.saveType?.toLowerCase() === 'other') {
        this.saveMsg = this.labelReplacer('msgSuccessDocReqApproval');
      }
      else if (emitSaveVersion?.saveType?.toLowerCase() === 'self') {
        this.saveMsg = this.labelReplacer('msgSuccessDocApproval');
      }
    }

    this.refreshDocTree();

  }

  validateTree() {

    if (this.targetTreeData.length > 0) {
      this.inValidFieldCounter = 0; //reset counter
      this.targetTreeData.forEach(node => {
        this.checkTreeRecursive(node);
      });

      this.inValidFieldCounter > 0 ? this.isValid = false : this.isValid = true;
    }
  }

  checkTreeRecursive(node: TreeNode) {
    if (node == undefined || node == null || typeof node == 'undefined')  {
      this.inValidFieldCounter++;
      return;
    }
    else 
    {
      if (node.children == undefined || node.children == null)
      {
        this.inValidFieldCounter++;
        return;
      }
      else {
        node.children.forEach(childNode => {
          this.checkTreeRecursive(childNode);
        });
      }
    }
  }



  saveTree(showMsg) {

    this.spinner.show();
    this.validateTree();
    if (this.isValid) {
      this.folderService.saveFolderTemplate(this.targetTreeData, this.engagementDetail.engagementId).subscribe(res => {
        if (res.status === 0) {
          //success
          if (showMsg) {
            this.messageService.add({
              summary: this.labelReplacer('msgTypeSuccess'),
              detail: this.saveMsg,
              sticky: false,
              severity: 'success'
            });
          }

        } else {
          //display error
          this.messageService.add({
            summary: this.labelReplacer('msgTypeError'),
            detail: res.message,
            sticky: false,
            severity: 'error'
          });
        }

        this.spinner.hide();

      });
    }
    else {
      this.spinner.hide();
      this.messageService.add({
        summary: this.labelReplacer('msgErrorType'),
        detail: this.labelReplacer('msgTypeErrorDragDrop'),
        sticky: false,
        severity: 'error'
      });
    }
  }

  disableDelete(rowData) {
    let isDisabled = true;
    let otherPrimaryLang = 0;
    const isDraftInOpl = (x) => (Number(x.languageId) === Number(otherPrimaryLang) && Number(x.statusId) === 1);
    const isOtherLangDraftExist = (x) => (Number(x.languageId) !== 1 && Number(x.languageId) !== 2 && Number(x.statusId) === 1);

    if (Number(rowData['statusId']) === 1) {
      //allow delete if only one draft version exists for docid
      if (this.docVersionList.length == 1)
        isDisabled = false;
      else {
        if (Number(rowData['languageId']) === 1) { //english
          otherPrimaryLang = 2; //french
        }
        else if (Number(rowData['languageId']) === 2)//french
        {
          otherPrimaryLang = 1; //english
        }

        if (Number(rowData['languageId']) === 1 || Number(rowData['languageId']) === 2) {
          //check if OPL draft exists
          if (this.docVersionList.findIndex(isDraftInOpl) > -1) {
            isDisabled = false;
          }
          else {
            //check if draft exists in any other language
            if (this.docVersionList.some(isOtherLangDraftExist)) {
              isDisabled = true;
            }
            else {
              isDisabled = false;
            }
          }

        }
        else {
          isDisabled = false;
        }
      }

    }
    return isDisabled;
  }




  editDocVersion() {
    this.spinner.show();
    return new Promise((resolve, reject) => {

      this.showEditSideBar = true;
      this.editDocVersionList = [];
      this.computeDocPerLang()
        .then(res => this.spinner.hide())
        .catch((error) => {
          console.log(error);
          this.spinner.hide();
        });
      resolve(1);
    })
      .catch((error) => {
        console.log(error);
        this.spinner.hide();
      });
  }

  computeDocPerLang() {

    return new Promise((resolve, reject) => {

      let docByLangList: any[];
      let nonDraftIndex = -1;
      let draftIndex = -1;
      let editDocLangList: any[] = [];
      let showDraftButton: boolean = false;
      let showDraftIcon: boolean = false;
      let showPendingDraftIcon = false;
      this.canApproveOtherLang = false;


      const isAnyNonDraft = (x) => ((!x.currentAuthorized && !x.currentDraft)
        || (x.currentAuthorized && !x.currentDraft));
      const isApprovedInPrimaryLang = (x) => ((x.languageId === 1 || x.languageId === 2) && x.currentAuthorized && !x.currentDraft);

      this.canApproveOtherLang = this.gridVersionList.some(isApprovedInPrimaryLang);

      this.isAllNonApproved = this.gridVersionList.every(x => !x.currentAuthorized);
      if (this.gridVersionList.length > 0) {
        this.engagementDetail.engLanguage.forEach(engLang => {
          docByLangList = this.gridVersionList.filter(x => Number(x.languageId) === Number(engLang.languageId));

          if (docByLangList && docByLangList.length > 0) {
            //check for non draft doc if any to show on LHS for language tab
            if ((nonDraftIndex = docByLangList.findIndex(isAnyNonDraft)) > -1) {
              showDraftButton = true;
              editDocLangList.push(
                docByLangList[nonDraftIndex]
              );
            }

            //check for existing draft (if any)
            if ((draftIndex = docByLangList.findIndex(x => Number(x.statusId) === 1)) > -1) {
              showDraftButton = false;
              showDraftIcon = true;
              if (docByLangList[draftIndex].isPendingApproval) {
                showPendingDraftIcon = true;
                showDraftIcon = false;
              }
              editDocLangList.push(
                docByLangList[draftIndex]
              );
            }

          }
          else {
            editDocLangList.push({
              approvalRequestedByGpn: null,
              approvalRequestedDateTime: null,
              approvalRequestedFromEmail: null,
              approvalRequestedFromGpn: null,
              authorizationEndDateTime: null,
              authorizationEndedByGpn: null,
              authorizedByGpn: null,
              authorizedDateTime: null,
              cloneFilePath: null,
              createdBy: null,
              createdByGpn: null,
              createdDate: null,
              currentAuthorized: false,
              currentDraft: true,
              docId: this.gridVersionList[0].docId,
              docVersionId: 0,
              documentDate: null,
              documentDescription: null,
              documentHash: null,
              documentLink: null,
              documentTitle: null,
              documentType: this.gridVersionList[0]?.documentType,
              documentTypeId: this.gridVersionList[0]?.documentTypeId,
              externalViews: null,
              fileLength: 0,
              fileStream: null,
              fileType: null,
              isFileUploaded: false,
              isPendingApproval: false,
              languageId: engLang.languageId,
              languageName: engLang.languageName,
              modifiedBy: null,
              modifiedDate: null,
              postedDate: null,
              status: null,
              statusId: 1,
              statusName: 'Draft'
            })
          }

          //pending check for authorized doc

          this.editDocVersionList.push(
            {
              languageId: engLang.languageId,
              languageName: engLang.languageName,
              languageDocList: editDocLangList,
              showDraftButton: showDraftButton,
              showDraftIcon: showDraftIcon,
              showPendingDraftIcon: showPendingDraftIcon
            }
          )

          //reset indices
          editDocLangList = [];
          draftIndex = -1;
          nonDraftIndex = -1;
          showDraftButton = false;
          showDraftIcon = false;
          showPendingDraftIcon = false;

        });
      }
      resolve(1);
    })
      .catch(error => {
        console.log(error);
      });
  }

  viewFileVersion(fileNode) {
    this.spinner.show();
    if (fileNode?.data) {
      this.manageDocService.getDocVersionByDocId(fileNode.data[0]).subscribe(res => {
        if (res?.data) {
          //success
          this.docVersionList = res.data['documentVersionList'];
          this.showDocVersionTypeId = res.data['documentTypeId'];
          this.formatVersionList();
        } else {
          //display error
          this.messageService.add({
            summary: this.labelReplacer('msgTypeErrorDocVersion'),
            detail: res.message,
            sticky: false,
            severity: 'error'
          });
        }
        this.spinner.hide();

      });
    }
    else {
      this.spinner.hide();

      this.messageService.add({
        summary: this.labelReplacer('msgTypeErrorDocVersion'),
        detail: '',
        sticky: false,
        severity: 'error'
      });
    }


  }

  viewTopicFileVersion(fileNode) {
    this.spinner.show();
    if (fileNode) {
      this.manageDocService.getDocVersionByDocId(fileNode).subscribe(res => {
        if (res?.data) {
          //success
          this.docVersionList = res.data['documentVersionList'];
          this.showDocVersionTypeId = res.data['documentTypeId'];
          this.formatVersionList();
        } else {
          //display error
          this.messageService.add({
            summary: this.labelReplacer('msgTypeErrorDocVersion'),
            detail: res.message,
            sticky: false,
            severity: 'error'
          });
        }
        this.spinner.hide();

      });
    }
    else {
      this.spinner.hide();

      this.messageService.add({
        summary: this.labelReplacer('msgTypeErrorDocVersion'),
        detail: '',
        sticky: false,
        severity: 'error'
      });
    }


  }


  getCompactHistory() {
    this.compactHistoryList = [];
    let cloneHistory = [];
    let processedVersionList = [];
    if (this.documentVersionHistoryModel?.length > 0) {
      cloneHistory = _.cloneDeep(this.documentVersionHistoryModel);

      cloneHistory.forEach(x => {
        if (!processedVersionList.includes(x.docVersionId)) {
          this.compactHistoryList.push(x);
          processedVersionList.push(x.docVersionId);
        }
      });

      this.formatHistoryList(this.compactHistoryList);
    }
  }



  getDocumentsHistory(fileNode) {
    return new Promise((resolve, reject) => {

      this.spinner.show();
      var docId = fileNode.data[0].docId;
      this.DocService.getDocVersionHistoryList(docId)
        .subscribe
        (
          (resp) => {
            this.documentVersionHistoryModel = resp;
            if (this.documentVersionHistoryModel.length > 0) {
              this.getCompactHistory();
              this.formatHistoryList(this.documentVersionHistoryModel);
              resolve(1);
              this.spinner.hide();
            }
            else{
              this.spinner.hide();
            }
          }
        );
    });
  }

  formatHistoryList(historyList) {
    historyList.forEach(elements => {
      elements.statusName = this.statusReplacer(elements.statusId);
      elements.languagePath = this.appLangList.filter(x=> Number(x.languageId)==Number(elements.languageId))[0]?.languageFlagPath;
      elements.languageName = this.languageReplacer(elements.languageName);
      elements.createdDate = this.monthReplacer(this.datePipe.transform(elements.createdDate, 'dd MMM yyyy  HH:mm:ss'));
      elements.logCreatedDate = this.monthReplacer(this.datePipe.transform(elements.logCreatedDate, 'dd MMM yyyy HH:mm:ss'));
      elements.documentDate = this.monthReplacer(this.datePipe.transform(elements.documentDate, 'dd MMM yyyy'));
      elements.approvalRequestedStringFormat = this.monthReplacer(this.datePipe.transform(elements.approvalRequestedDateTime, 'dd MMM yyyy HH:mm:ss'));
      elements.authorizedStringFormat = this.monthReplacer(this.datePipe.transform(elements.authorizedDateTime, 'dd MMM yyyy HH:mm:ss'));
      elements.authorizationEndStringFormat = this.monthReplacer(this.datePipe.transform(elements.authorizationEndDateTime, 'dd MMM yyyy HH:mm:ss'));
      elements.postedDateStringFormat = this.monthReplacer(this.datePipe.transform(elements.postedDate, 'dd MMM yyyy HH:mm:ss'));
    });

    return historyList;
  }

  formatVersionList() {
    if (this.docVersionList.length > 0) {
      this.docVersionList.forEach(docVersion => {
        //docVersion.languageName = this.appLangList.filter(x => Number(x.languageId) === Number(docVersion.languageId))[0]?.languageName;
        //docVersion.statusName = this.statusReplacer(this.docStatusList.filter(x => Number(x.statusId) === Number(docVersion.statusId))[0]?.name);
        //docVersion.documentType = this.docTypeReplacer(this.docTypeList.filter(x => Number(x.documentTypeId) === Number(this.showDocVersionTypeId))[0]?.documentTypeDescription);
        docVersion.languageName = this.languageReplacer(this.appLangList.filter(x => Number(x.languageId) === Number(docVersion.languageId))[0]?.languageName);
        docVersion.languagePath = this.appLangList.filter(x=> Number(x.languageId)==Number(docVersion.languageId))[0]?.languageFlagPath;
        docVersion.statusName = this.statusReplacer(docVersion.statusId);
        docVersion.documentType = this.docTypeReplacer(this.showDocVersionTypeId);
        docVersion.documentTypeId = this.showDocVersionTypeId;
        docVersion.documentDate = this.datePipe.transform(docVersion.documentDate, "dd MMM yyyy");
        docVersion.documentDateStr = this.monthReplacer(this.datePipe.transform(docVersion.documentDate, "dd MMM yyyy"));
        docVersion.authorizedDateTime = this.monthReplacer(this.datePipe.transform(docVersion.authorizedDateTime, "dd MMM yyyy"));
        docVersion.authorizedByEmail = docVersion?.authorizedByGpn; //this.userList.filter(x => x.gpn?.toLowerCase() === docVersion?.authorizedByGpn?.toLowerCase())[0]?.emailId;
        docVersion.isPendingApproval = false;
      });

      if (this.docVersionList.some(x => Number(x.statusId) === 2 ||
        Number(x.statusId) === 4 || Number(x.statusId === 7))) {
        this.isApproveDisabled = false;
        this.isUnapproved = false;
      }
      else {
        this.isApproveDisabled = true;
        this.isUnapproved = true;
      }

      this.getGridVersionList();

    }
  }

  getGridVersionList() {
    let versionLangList, unauthorizedList: any[] = [];
    let draftIndex, authorizedIndex, unauthorizedIndex = -1;
    this.gridVersionList = [];
    const isVersionAuthorized = (x) => (!x.currentDraft && x.currentAuthorized);
    const isVersionDraft = (x) => (x.currentDraft && !x.currentAuthorized);
    const isDraftAuthPending = (x) => (!x.currentAuthorized && x.currentDraft
      && x.approvalRequestedByGpn != null && x.approvalRequestedFromGpn != null
      && x.authorizedByGpn === null && x.authorizedDateTime === null);

    this.engagementDetail.engLanguage.forEach(engLang => {

      versionLangList = this.docVersionList.filter(x => Number(x.languageId) === Number(engLang.languageId));

      if (versionLangList && versionLangList.length > 0) {

        draftIndex = versionLangList.findIndex(isVersionDraft);
        if (draftIndex > -1) {
          if (isDraftAuthPending(versionLangList[draftIndex])) {
            versionLangList[draftIndex].isPendingApproval = true;
          }
          this.gridVersionList.push(versionLangList[draftIndex]);
        }

        authorizedIndex = versionLangList.findIndex(isVersionAuthorized);

        if (authorizedIndex > -1) {
          this.gridVersionList.push(versionLangList[authorizedIndex]);
        }
        else {
          if (versionLangList.some(x => !x.currentAuthorized && !x.currentDraft)) {
            unauthorizedList = versionLangList?.filter(x => !x.currentAuthorized && !x.currentDraft).sort(this.date_sort_desc);
            if (unauthorizedList && unauthorizedList.length > 0) {
              this.gridVersionList.push(unauthorizedList[0]);
            }
          }

        }

      }
    });

  }



  date_sort_desc = function (a, b) {
    // This is a comparison function that will result in dates being sorted in
    // DESCENDING order.
    a = new Date(a.authorizationEndDateTime);
    b = new Date(b.authorizationEndDateTime);
    return a > b ? -1 : a < b ? 1 : 0;
  };



  onAddPanelHide() {
    this.showSideBar = false;
    this.uploadNewDoc.forEach(childRef => childRef.resetForm());
    this.addTabIndex = 0;
  }


  onEditPanelHide() {
    this.showEditSideBar = false;
    this.editTabIndex = 0;
  }

  viewLog() {
    this.showHistory = true;
    this.showCompactLog = true;
    this.getDocumentsHistory(this.selectedNode)
      .then(res => this.viewLogList = this.compactHistoryList);
  }

  toggleLogClick() {
    this.showCompactLog = !this.showCompactLog;
    this.getDocumentsHistory(this.selectedNode);
    this.viewLogList = this.showCompactLog ? this.compactHistoryList : this.documentVersionHistoryModel;
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }


  exportExcel() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.getDocuments());
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "documentVersionHistoryLogs");
    });
  }

  public selectionItemForFilter(e) {
    const colsTempor = e.value;
    colsTempor.sort(function (a, b) {
      return a.index - b.index;
    });
    this.colmns = [];
    this.colmns = colsTempor;
    if (e.value.length > 23) {
      e.value.pop();
    }
  }

  versionGridFilter(e) {
    const colsTempor = e.value;
    colsTempor.sort(function (a, b) {
      return a.index - b.index;
    });
    this.cols = [];
    this.cols = colsTempor;
    if (e.value.length > 8) {
      e.value.pop();
    }
  }

  getDocuments() {
    let lstofdocument = [];
    for (let documents of this.documentVersionHistoryModel) {

      documents.docId = documents.docId;
      lstofdocument.push(documents);
    }
    return lstofdocument;
  }

  deleteFileVersion(file) {
    const initialState = {
      paramList: {
        displayMessage: this.labelReplacer('lblDeleteDraftModal'),
        showFootNote: false,
        footNote: ''
      }
    };

    this.bsModalRef = this.modalService.show(ModalContentComponent, { initialState });
    this.bsModalRef.content.event.subscribe(res => {
      if (res.data) {
        //yes
        this.spinner.show();

        let deleteNode = this.getDeleteFile(file);

        if (!_.isEmpty(deleteNode)) {
          //delete file from json
          let index = deleteNode.parent.children.indexOf(deleteNode);
          if (index > -1) {
            deleteNode.parent.children.splice(index, 1);
            //update in table and blob
            this.manageDocService.deleteDocVersion(file).subscribe(res => {
              if (res.status === 0) {
                //success
                this.saveMsg = this.labelReplacer('msgSuccessDeleteDraft');

              } else {
                //display error
                this.messageService.add({
                  summary: this.labelReplacer('msgTypeErrorDelete'),
                  detail: res.message,
                  sticky: false,
                  severity: 'error'
                });

              }

              this.refreshDocTree().then(res => {
                if (this.docVersionList?.length > 1) {
                  this.viewFileVersion(deleteNode);
                }
                else {
                  this.showFileVersionGrid = false;
                  //this.docVersionList = [];
                }
              });

              this.spinner.hide();

            });
          }
          else {
            //display error
            this.spinner.hide();
            this.messageService.add({
              summary: this.labelReplacer('msgTypeErrorDelete'),
              detail: this.labelReplacer('msgDelete404'),
              sticky: false,
              severity: 'error'
            });
          }
        }
        else {
          this.spinner.hide();
          this.messageService.add({
            summary: this.labelReplacer('msgTypeErrorDelete'),
            detail: this.labelReplacer('msgDelete404'),
            sticky: false,
            severity: 'error'
          });

        }
      }
      else {
        //do nothing
      }
    });

  }


  getDeleteFile(file): TreeNode {

    let node: TreeNode = {};
    // this.selectedNode?.parent?.children?.forEach(childNode => {
    //   if (Number(childNode?.data[0]?.docId) === Number(file.docId)
    //     && Number(childNode?.data[0]?.docVersionId) === Number(file.docVersionId)) {
    //     node = childNode;
    //   }
    // });

    if (this.selectedNode?.parent?.children) {
      this.selectedNode.parent.children.forEach(r => {
        if (Number(r?.data[0]?.docId) === Number(file.docId)
          && Number(r?.data[0]?.docVersionId) === Number(file.docVersionId)) {
          node = r;
        }
      })
    }

    return node;
  }

  unapproveDocument(e) {
    this.spinner.show();
    if (e.checked) {
      let documentToUnapprove = this.selectedNode;
      if (documentToUnapprove) {
        this.manageDocService.unapproveDocument(documentToUnapprove.data[0]).subscribe(res => {
          if (res.status === 0) {
            //success
            this.saveMsg = this.labelReplacer('msgSuccessUnapprove');

            // this.messageService.add({
            //   summary: this.labelReplacer('msgTypeSuccess'),
            //   detail: 'Document unapproved successfully',
            //   sticky: false,
            //   severity: 'success'
            // });
          } else {
            //display error
            this.messageService.add({
              summary: this.labelReplacer('msgTypeErrorUnapprove'),
              detail: res.message,
              sticky: false,
              severity: 'error'
            });
          }

          this.refreshDocTree().then(res =>
            this.viewFileVersion(this.selectedNode));
          this.spinner.hide();

        });
      }
      else {
        this.spinner.hide();

      }
    }
  }

  refreshDocTree() {
    return new Promise((resolve, reject) => {
      this.getEngagementDoc()
        .then(res => this.preProcessTree()
          .then(res => this.saveTree(true)));
      resolve(1);
    })
  }

  getSavedVersion(emitSaveVersion) {
    this.spinner.show();

    let updateNode: TreeNode = {};
    let savedVersionData = emitSaveVersion.versionData;
    this.showEditSideBar = false;

    if (emitSaveVersion.isNewVersion) {
      //add uploaded version to tree json

      this.selectedNode.parent.children.push({
        label: savedVersionData?.documentTitle,
        key: Date.now().toString(),
        type: "file",
        data: [{
          parentId: this.selectedNode.parent.key,
          docId: savedVersionData?.docId,
          docVersionId: savedVersionData?.docVersionId,
          languageId: savedVersionData?.languageId,
          isFileUploaded: savedVersionData?.isFileUploaded,
          documentDate: savedVersionData?.documentDate,
          createdDTTM: new Date(savedVersionData.createdDate)?.toUTCString(),
          fileSize: savedVersionData?.fileLength, //IN MB Math.ceil
          fileType: savedVersionData?.fileType,
          fileTypeIcon: '',
          fileIconStyle: '#000',
          showRedMark: false,
          showDraftMark: false
        }],
        styleClass: "fileClass",
        children: [],
        draggable: true
      } as TreeNode);

      //sort folder
      this.sortNode(this.selectedNode.parent);
      this.selectedNode.parent.expanded = true;
    }
    else {
      if (emitSaveVersion?.saveType?.toLowerCase() === 'draftapproved') {
        //do nothing
      }
      else if (emitSaveVersion?.saveType?.toLowerCase() === 'draftdeleted') {
        //do nothing
      }
      else {

        let updateNodeIndex = this.selectedNode?.parent?.children
          .findIndex(x => Number(x.data[0]?.docId) === (savedVersionData?.docId)
            && Number(x.data[0]?.docVersionId) === Number(savedVersionData?.docVersionId))

        if (updateNodeIndex > -1) {
          updateNode = this.selectedNode?.parent?.children[updateNodeIndex];
          updateNode.label = savedVersionData?.documentTitle,
            updateNode.data[0].isFileUploaded = savedVersionData?.isFileUploaded,
            updateNode.data[0].documentDate = savedVersionData?.documentDate,
            updateNode.data[0].fileSize = savedVersionData?.fileLength, //IN MB Math.ceil
            updateNode.data[0].fileType = savedVersionData?.fileType,
            updateNode.data[0].fileTypeIcon = '',
            updateNode.data[0].fileIconStyle = '#000',
            updateNode.data[0].showRedMark = false,
            updateNode.data[0].showDraftMark = false
        }
      }

    }

    //auto save tree with new file added
    if (emitSaveVersion?.saveType?.toLowerCase() === 'save') {
      this.saveMsg = this.labelReplacer('msgSuccessDocSave');

    }
    else if (emitSaveVersion?.saveType?.toLowerCase() === 'other') {
      this.saveMsg = this.labelReplacer('msgSuccessDocReqApproval');

    }
    else if (emitSaveVersion?.saveType?.toLowerCase() === 'self') {
      this.saveMsg = this.labelReplacer('msgSuccessDocApproval');
    }

    this.refreshDocTree()
      .then((res) => {
        return new Promise((resolve, reject) => {
          this.viewFileVersion(this.selectedNode);
          resolve(1);
        })
          .then(res => this.spinner.hide())
          .catch(error => {
            console.log(error);
            this.spinner.hide();
          })
      })
      .catch((error) => {
        console.log(error);
        this.spinner.hide();
      });

  }

  onTabChange(event, tabControl) {
    var selectedIndex = event.index;
    const initialState = {
      paramList: {
        displayMessage: this.labelReplacer('lblUnsavedChangesModal'),
        showFootNote: true,
        footNote: this.labelReplacer('lblFootNoteModal')
      }
    };

    if (tabControl.toLowerCase() === 'add') {
      let addChild = this.uploadNewDoc['_results'][this.addTabIndex];
      if (addChild?.documentForm.dirty) {
        this.bsModalRef = this.modalService.show(ModalContentComponent, { initialState });
        this.bsModalRef.content.event.subscribe(res => {
          if (res.data) {
            this.addTabIndex = selectedIndex;
          }
          else {
            this.ctrlAddTab.forEach((element, index) => {
              if (index === this.addTabIndex) {
                element['selected'] = true;
              }
              else {
                element['selected'] = false;
              }
            });
          }
        });
      }
      else {
        this.addTabIndex = selectedIndex;
      }
    }
    else if (tabControl.toLowerCase() === 'edit') {
      let editChild = this.editDoc['_results'][this.editTabIndex];
      if (editChild?.documentForm?.dirty) {
        this.bsModalRef = this.modalService.show(ModalContentComponent, { initialState });
        this.bsModalRef.content.event.subscribe(res => {
          if (res.data) {
            this.editTabIndex = selectedIndex;
          }
          else {
            this.ctrlEditTab.forEach((element, index) => {
              if (index === this.editTabIndex) {
                element['selected'] = true;
              }
              else {
                element['selected'] = false;
              }
            });
          }
        });
      }
      else {
        this.editTabIndex = selectedIndex;
      }
    }

  }

  getTabIcon(lang): string {
    let piClass = '';
    if (lang) {
      if (lang.showDraftIcon) {

        piClass = 'pi pi-user-edit';
      }
      else if (lang.showPendingDraftIcon) {
        piClass = 'pi pi-exclamation-circle';

      }
    }
    return piClass;
  }

  downloadFileVersion(file) {
    return new Promise((resolve, reject) => {
      this.spinner.show();
      if (file) {
        var languageCode = this.languageLists.filter(item=>item.languageId==file.languageId)[0]?.languageCode;
        var popupMessage =this.labelReplacer('PleasedisableyourPop-upblockerandtryagain');
        let downloadModel = new downloadDocument(+this.engagementDetail?.engagementId,
          +file?.docId, +file?.docVersionId, file?.documentTitle,
          '.' + file?.documentLink?.split('.').pop(),languageCode);
        this.manageDocService.getDownloadDocumentwithVersion(downloadModel,popupMessage).subscribe(res => {
          this.spinner.hide();
          resolve(1);
        });
      }
    })
      .catch(error => {
        console.log(error)
        this.spinner.hide();
      });
  }

  sortNode(node: TreeNode) {

    if (!('sortTypeId' in node?.data[0])) {
      node.data[0]['sortTypeId'] = '2';
    }

    if (node?.data[0]?.sortTypeId.toString() === '1') {
      // node.draggable = false;
      // node.droppable = false;

      if (node.children) {
        //node?.children?.sort((a, b) => a.label?.localeCompare(b.label));
        node?.children?.sort((a, b) => this.displayFolderLabel(a).localeCompare(this.displayFolderLabel(b)));


      }
    }
    else if (node?.data[0]?.sortTypeId.toString() === '2') {
      // node.draggable = false;
      // node.droppable = false;

      if (node.children) {
        //node?.children?.sort((a, b) => a.label?.localeCompare(b.label));
        node?.children?.sort((a, b) => this.displayFolderLabel(a).localeCompare(this.displayFolderLabel(b)));
        node?.children?.sort(this.folder_date_sort_desc);

      }
    }
    else if (node?.data[0]?.sortTypeId.toString() === '3') {

    }
    else if (node?.data[0]?.sortTypeId.toString() === '4') {

      //node?.children?.sort((a, b) => b.label?.localeCompare(a.label));
      node?.children?.sort((a, b) => this.displayFolderLabel(b).localeCompare(this.displayFolderLabel(a)));
      node?.children?.sort((a, b) => this.folder_date_sort_desc(a, b));

    }
  }


  folder_date_sort_desc = function (a, b) {
    // This is a comparison function that will result in dates being sorted in
    // DESCENDING order.
    let res;
    if (a?.type?.toLowerCase() === 'file') {
      a = new Date(a?.data[0]?.documentDate).getTime() ?? new Date(a?.data[0]?.createdDTTM).getTime();
    }
    else {
      a = new Date(a?.data[0]?.createdDTTM).getTime();
    }

    if (b?.type?.toLowerCase() === 'file') {
      b = new Date(b?.data[0]?.documentDate).getTime() ?? new Date(b?.data[0]?.createdDTTM).getTime();
    }
    else {
      b = new Date(b?.data[0]?.createdDTTM).getTime();
    }

    res = a > b ? -1 : a < b ? 1 : 0;

    return res;

  }


  // Start function
  findDocument(fileVersionId): TreeNode {

    var found = false;
    let foundNode: TreeNode = {};

    function recurseFindParent(searchTree) {

      for (var i = 0; i < searchTree.length; i++) {

        // Found the category!
        if (searchTree[i]?.type?.toLowerCase() === 'file') {
          if (Number(searchTree[i]?.data[0]?.docVersionId) === Number(fileVersionId)) {
            foundNode = searchTree[i];
            found = true;
            break;
          }
          // Did not match...
        } else {
          // Are there children / sub-categories? YES
          if (searchTree[i].children.length > 0) {
            recurseFindParent(searchTree[i].children);
            if (found) {
              break;
            }
          }
        }
      }
    }

    recurseFindParent(this.targetTreeData);

    return foundNode;
  }

}


export class downloadDocument {
  EngagementId: Number;
  DocId: any;
  DocVersionId: any;
  FileName: any;
  FileType: any;
  LanguageCode:any;
  constructor(engagementId: Number, docId: any, docVersionId: any, fileName: any, fileType: any,languageCode: any) {
    this.EngagementId = engagementId;
    this.DocId = docId;
    this.DocVersionId = docVersionId;
    this.FileName = fileName;
    this.FileType = fileType;
    this.LanguageCode=languageCode;
  }
}

